import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';



const Footer = () => {
    
    const [officeFacebook, setOfficeFacebook] = useState('');
    const [officeInsta, setOfficeInsta] = useState('');
    const [officeLinkden, setOfficeLinkden] = useState('');

    useEffect(() => {
        const facebook = process.env.REACT_APP_FACEBOOK;
        const insta = process.env.REACT_APP_INSTA;
        const linkden = process.env.REACT_APP_LINKDEN;
        setOfficeFacebook(facebook);
        setOfficeInsta(insta);
        setOfficeLinkden(linkden)

    }, [])

    return (
        <footer className="bg-gray-800 text-white">
            <div className="max-w-full mx-auto px-4 sm:px-6 py-10 border-t border-gray-700">

                {/* Top area: Blocks */}
                <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-blue-500 p-8 bg-gray-700 text-gray-300 text-center rounded-lg xl:w-80 mx-auto">
                            <h3 className="font-bold text-4xl mb-4">WMK-Tech</h3>
                            <div className='text-md font-medium'>
                                <h5>Molad e Konsult</h5>
                                <p>Ilo Awela,</p>
                                <p>Ota,</p>
                                <p>Ogun State.</p>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-1 mx-auto">
                        <h6 className="text-blue-500 text-xl font-bold mb-4">LINKS</h6>
                        <ul className="text-md">
                            <li className="mb-2">
                                <HashLink to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">About</HashLink>
                            </li>
                            <li className="mb-2">
                                <HashLink to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">Services</HashLink>
                            </li>
                            <li className="mb-2">
                                <HashLink to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">Contact</HashLink>
                            </li>
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-blue-500 text-xl font-bold mb-4">OUR SERVICES</h6>
                        <ul className="text-md">
                            <li className="mb-2">
                                <Link to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">Web Development</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">Mobile App Development</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">Domain and Hosting</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="#" className="text-blue-400 hover:text-gray-300 transition duration-250 ease-in-out">General IT Consultations</Link>
                            </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-blue-500">
                        <div className="text-xl mb-6">Social Media Links</div>
                        <div className="text-md font-medium mb-6">Follow us on social media.</div>
                        <div className="mx-auto text-center mt-2">
                            <ul className="flex justify-center mb-4 md:mb-0">
                                <li>
                                    <a href={officeFacebook} className="flex justify-center items-center text-blue-500 hover:text-gray-300 bg-gray-700 rounded-full shadow transition duration-150 ease-in-out" aria-label="Twitter">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                                        </svg>
                                    </a>
                                </li>
                                <li className="ml-4">
                                    <a href={officeLinkden} className="flex justify-center items-center text-blue-500 hover:text-gray-300 bg-gray-700 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                    </a>
                                </li>
                                {/* <li className="ml-4">
                                    <a href={officeInsta} className="flex justify-center items-center text-blue-500 hover:text-gray-300 bg-gray-700 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" fill="#0F0F0F" />
                                        <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" fill="#0F0F0F" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z" fill="#0F0F0F" />
                                     </svg>
                                    </a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom area */}
                <div className="text-center text-gray-400 text-sm">
                    <p>&copy; {new Date().getFullYear()} WMK-Tech. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
